import React from 'react';
import Setting from '../Dashboard/Components/Setting/Setting';

const AccountSettings = React.memo(() => {
  return <Setting />;
});

AccountSettings.displayName = 'AccountSettings';

export default AccountSettings;
